(function () {
  function init() {
    var form = document.getElementById('teeinblue-form');
    if (!form || form.dataset.tibConvInjected === '1') return;
    form.dataset.tibConvInjected = '1';
    run(form);
  }

  // Run as soon as possible - if this script happens to load/execute
  // after DOMContentLoaded already fired (can happen with some section/
  // app-block loading orders), don't wait forever for an event that
  // will never come again.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function run(form) {

  // --------------------------------------------------------------
  // ANTI-LAYOUT-LOOP-INFRASTRUKTUR
  //
  // Jeder Schreibvorgang auf "style" oder "class" erzeugt einen
  // MutationRecord - auch dann, wenn der Wert danach exakt derselbe
  // ist wie vorher. Da unser eigener MutationObserver (weiter unten)
  // auf genau solche Aenderungen hoert, wuerde jeder blinde
  // Schreibvorgang uns selbst erneut aufrufen: klassisches Layout
  // Thrashing / Endlosschleife (Symptom: TeeInBlue-Container waechst
  // staendig, Seite springt beim Scrollen).
  //
  // Regel ab hier: NIEMALS schreiben, wenn sich der Wert nicht
  // tatsaechlich aendert.
  // --------------------------------------------------------------
  function setStyle(el, prop, value) {
    if (!el || !el.style) return;
    if (el.style.getPropertyValue(prop) === value && el.style.getPropertyPriority(prop) === 'important') return;
    el.style.setProperty(prop, value, 'important');
  }

  function setClass(el, name, on) {
    if (!el || !el.classList) return;
    if (el.classList.contains(name) === !!on) return;
    el.classList.toggle(name, !!on);
  }

  // Begrenzt einen berechneten Padding-Wert hart auf [0, max]. Damit ist
  // ein Aufschaukeln ueber mehrere Durchlaeufe rechnerisch unmoeglich,
  // egal wie fehlerhaft eine einzelne Messung ausfaellt (z.B. weil ein
  // Bezugselement gerade ausgeblendet war und ein Null-Rechteck lieferte).
  function clampPadding(value, max) {
    if (!isFinite(value)) return 0;
    return Math.max(0, Math.min(Math.round(max), Math.round(value)));
  }

  // Ein Element, das gerade ausgeblendet oder noch nicht gerendert ist,
  // liefert ein Rechteck aus lauter Nullen. Rechnet man damit, kommen
  // absurde Basisabstaende heraus - und weil alle Werte VIEWPORT-relativ
  // sind, verschiebt das eigene Padding die Messpunkte gleich mit.
  function isMeasurable(el) {
    if (!el || !el.getClientRects || !el.getClientRects().length) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 || r.height > 0;
  }

  function insertBenefits() {
    try {
      if (form.querySelector('.tib-conv-benefits')) return true;
      var actions = form.querySelector('#teeFormActions') || form.querySelector('.tee-actions') || (form.querySelector('.tee-btn--atc') ? form.querySelector('.tee-btn--atc').parentElement : null);
      if (!actions) return false;

      var benefits = document.createElement('div');
      benefits.className = 'tib-conv-benefits';
      benefits.innerHTML =
        '<div class="tib-conv-benefit"><span class="tib-conv-dot"></span><span>Sichere Zahlung mit SSL-Verschlüsselung</span></div>' +
        '<div class="tib-conv-benefit"><span class="tib-conv-dot"></span><span>Hochwertiger Druck in Deutschland</span></div>' +
        '<div class="tib-conv-benefit"><span class="tib-conv-dot"></span><span>Kostenloser Versand nach DE/AT/CH</span></div>' +
        '<div class="tib-conv-benefit"><span class="tib-conv-dot"></span><span>Persönlicher Support bei Rückfragen</span></div>';
      actions.insertAdjacentElement('afterend', benefits);
      return true;
    } catch (err) {
      // Never let an unexpected DOM shape on one product break the
      // whole retry/observer loop for everyone else - just report
      // "not done yet" so the caller tries again on the next pass.
      return false;
    }
  }

  // The app's own (cross-origin) stylesheet forces a fixed, oversized
  // box on every background-colour/clipart swatch, and a small negative
  // left margin on the row, with a specificity our own <style> tag
  // can't reliably beat. Inline styles set with "important" always win,
  // regardless - so we enforce the fixed 60x60px tile size and the grid
  // layout directly here. Re-run whenever the app adds new swatch rows
  // (e.g. picking a breed from a dropdown reveals a brand-new
  // .tee-clipart-row) and on viewport resize, so exactly as many tiles
  // as fit the available width are shown per row - never more, never a
  // hardcoded count.
  function normalizeClipartBoxes() {
    try {
      var rows = form.querySelectorAll('.tee-clipart-row');
      if (!rows.length) return false;
      var isMobile = window.innerWidth <= 480;
      var colGap = isMobile ? 12 : 16;

      rows.forEach(function (row) {
      var cols = row.querySelectorAll('.tee-clipart-col');
      setStyle(row, 'display', 'grid');
      setStyle(row, 'grid-template-columns', 'repeat(auto-fill, 60px)');
      setStyle(row, 'justify-content', 'start');
      setStyle(row, 'column-gap', colGap + 'px');
      // +3px on top of the shared indent to compensate for the tile's
      // own "outline-offset" (see .tee-clipart-label), which otherwise
      // makes its visible ring start a few px left of every other
      // field's flush border.
      setStyle(row, 'margin-left', '3px');
      cols.forEach(function (col) {
        setStyle(col, 'width', '60px');
        setStyle(col, 'height', '60px');
        setStyle(col, 'min-width', '0');
        setStyle(col, 'max-width', 'none');
        setStyle(col, 'padding', '0');
        setStyle(col, 'margin', '0');
      });
    });
    form.querySelectorAll('.tee-clipart').forEach(function (box) {
      setStyle(box, 'width', '60px');
      setStyle(box, 'height', '60px');
      setStyle(box, 'min-width', '0');
      setStyle(box, 'min-height', '0');
      setStyle(box, 'border', 'none');
      setStyle(box, 'background', 'transparent');
      setStyle(box, 'box-shadow', 'none');
      setStyle(box, 'padding', '0');
    });
    form.querySelectorAll('.tee-clipart-label').forEach(function (label) {
      setStyle(label, 'width', '60px');
      setStyle(label, 'height', '60px');
    });

    // The caption below each tile is absolutely positioned (so it never
    // affects tile/track sizing) and therefore never pushes the row's
    // own edges - use ONE spacing value, based on the tallest caption
    // ANYWHERE in this row, for the gap between rows AND for the gap
    // above/below the tiles. Different field types (a plain heading vs.
    // a visibility toggle) already come with a different amount of
    // "free" spacing above/below built in from other rules, so rather
    // than blindly adding the same padding everywhere (which left top
    // and bottom looking uneven), measure how much space already
    // exists on each side with zero padding and only ever top it up to
    // the target - never add on top of spacing that's already there.
    rows.forEach(function (row) {
      var cols = row.querySelectorAll('.tee-clipart-col');
      if (!cols.length) {
        setStyle(row, 'padding-top', '0px');
        setStyle(row, 'padding-bottom', '0px');
        setStyle(row, 'row-gap', '0px');
        return;
      }
      var maxCaptionHeight = 0;
      row.querySelectorAll('.tee-clipart-label__text').forEach(function (caption) {
        var h = caption.getBoundingClientRect().height;
        if (h > maxCaptionHeight) maxCaptionHeight = h;
      });
      // caption's own margin-top (6px) + its measured height + a bit of
      // breathing room before the NEXT row of tiles (12px) - a little
      // more generous than the section spacing below, since this gap
      // sits between two rows of tiles and looked squeezed otherwise.
      var rowGapSpacing = Math.max(20, Math.ceil(maxCaptionHeight) + 6 + 12);
      setStyle(row, 'row-gap', rowGapSpacing + 'px');
      // caption's own margin-top (6px) + its measured height + a small
      // amount of breathing room (6px) - used for the section gaps
      // above/below (see spacing/bottomSpacing further down).
      var spacing = Math.max(20, Math.ceil(maxCaptionHeight) + 6 + 6);

      var field = row.closest('.tee-field');
      var heading = field ? field.querySelector('.tee-field__heading') : null;
      // Find whatever comes right after this field to equalize against.
      // Usually that's simply the next sibling ".tee-field" - but if
      // this is the LAST field inside #teeFormInputs (e.g. the very
      // last swatch picker before the separate "Passenden Rahmen"
      // frame-swatch section), the next relevant heading actually sits
      // right after the whole #teeFormInputs container instead, and
      // uses a different class (.tee-option__title, not
      // .tee-field__heading).
      var nextField = field ? field.nextElementSibling : null;
      var nextHeading = nextField ? nextField.querySelector('.tee-field__heading, .tee-option__title') : null;
      if (!nextHeading && field && !nextField) {
        var formInputs = field.closest('#teeFormInputs');
        var afterFormInputs = formInputs ? formInputs.nextElementSibling : null;
        nextHeading = afterFormInputs ? afterFormInputs.querySelector('.tee-field__heading, .tee-option__title') : null;
      }

      // WICHTIG: frueher wurde hier zuerst "padding: 0" geschrieben,
      // dann gemessen, dann der Endwert geschrieben. Das erzeugte pro
      // Durchlauf zwingend 2-4 DOM-Mutationen + 2 erzwungene Reflows -
      // selbst wenn sich am Ende nichts aenderte. Zusammen mit dem
      // MutationObserver weiter unten war das der Motor der
      // Endlosschleife.
      //
      // Stattdessen rechnen wir das aktuell gesetzte Padding einfach
      // heraus: ein padding-top von X verschiebt die Kacheln um genau
      // X nach unten, ein padding-bottom von Y verschiebt die naechste
      // Ueberschrift um genau Y nach unten. Ergebnis ist identisch,
      // aber ohne Zwischen-Schreibvorgang - und wenn sich nichts
      // aendert, wird gar nicht mehr geschrieben.
      var currentPadTop = parseFloat(getComputedStyle(row).paddingTop) || 0;
      var currentPadBottom = parseFloat(getComputedStyle(row).paddingBottom) || 0;

      // Reihe selbst unsichtbar? Dann gar nichts messen/schreiben.
      var rowRect = row.getBoundingClientRect();
      if (!rowRect.width && !rowRect.height) return;

      var baseTop = 0;
      if (isMeasurable(heading)) {
        var headingBottom = heading.getBoundingClientRect().bottom;
        var firstColTop = cols[0].getBoundingClientRect().top;
        // Plausibilitaet: die Ueberschrift MUSS oberhalb der Kacheln
        // liegen. Bei verschachtelten Feldern liefert querySelector()
        // sonst die Ueberschrift eines Unterfeldes, das UNTER der Reihe
        // sitzt - dann waechst das Padding bei jedem Durchlauf weiter.
        if (headingBottom <= firstColTop + 1) {
          baseTop = firstColTop - headingBottom - currentPadTop;
        }
      }

      // The bottom target only needs to fit the LAST row's own tallest
      // caption (not the tallest caption anywhere in the field) - using
      // the global max here would reserve far more trailing space than
      // necessary whenever an earlier row happens to have the longest
      // name. This is computed regardless of whether a "next heading"
      // was found, since it also sets the floor for the plain fallback
      // case below.
      var maxColTop = -Infinity;
      cols.forEach(function (col) { if (col.offsetTop > maxColTop) maxColTop = col.offsetTop; });
      var lastRowMaxCaptionHeight = 0;
      var lastRowCaptionBottom = 0;
      cols.forEach(function (col) {
        if (col.offsetTop !== maxColTop) return;
        var caption = col.querySelector('.tee-clipart-label__text');
        if (!caption) return;
        var rect = caption.getBoundingClientRect();
        if (rect.height > lastRowMaxCaptionHeight) lastRowMaxCaptionHeight = rect.height;
        if (rect.bottom > lastRowCaptionBottom) lastRowCaptionBottom = rect.bottom;
      });
      var baseBottom = 0;
      var hasUsableNextHeading = false;
      if (isMeasurable(nextHeading) && lastRowCaptionBottom > 0) {
        var nextHeadingTop = nextHeading.getBoundingClientRect().top;
        // Gleiche Plausibilitaetspruefung wie oben, nur andersherum:
        // die naechste Ueberschrift muss UNTERHALB der letzten
        // Bildunterschrift liegen.
        if (nextHeadingTop >= lastRowCaptionBottom - 1) {
          baseBottom = nextHeadingTop - lastRowCaptionBottom - currentPadBottom;
          hasUsableNextHeading = true;
        }
      }
      var bottomSpacing = Math.max(20, Math.ceil(lastRowMaxCaptionHeight) + 6 + 6);

      // Harte Obergrenze - das ist die eigentliche Notbremse gegen das
      // Aufschaukeln: wir wollen den Abstand ja nur bis auf "spacing"
      // AUFFUELLEN. Ist bereits Platz vorhanden, wird das Padding
      // kleiner; ist gar keiner da, brauchen wir genau "spacing". Mehr
      // als "spacing" kann rechnerisch nie richtig sein - egal wie
      // kaputt eine Einzelmessung ausfaellt.
      var nextPadTop = clampPadding(spacing - baseTop, spacing);
      var nextPadBottom = hasUsableNextHeading
        ? clampPadding(bottomSpacing - baseBottom, bottomSpacing)
        : bottomSpacing;

      // Totzone von 2px gegen Subpixel-Zittern (sonst schreiben wir bei
      // jedem Durchlauf 17px/18px/17px/... und halten den Observer wach).
      if (Math.abs(nextPadTop - currentPadTop) >= 2 || !row.style.paddingTop) {
        setStyle(row, 'padding-top', nextPadTop + 'px');
      }
      if (Math.abs(nextPadBottom - currentPadBottom) >= 2 || !row.style.paddingBottom) {
        setStyle(row, 'padding-bottom', nextPadBottom + 'px');
      }
    });

    return true;
    } catch (err) {
      // Same reasoning as insertBenefits() above - fail soft, try again
      // on the next pass instead of taking the whole mechanism down.
      return false;
    }
  }

  // Belt-and-suspenders for the CSS ":has()" rules used elsewhere in
  // this stylesheet: ":has()" only reached broad browser support in
  // 2023/2024 (Firefox in particular didn't ship it until December
  // 2023), so on an older browser those rules are silently ignored
  // rather than causing an error - a step-numbering/spacing nicety
  // quietly reverting to the plain default. This mirrors the exact
  // same logic with plain DOM checks and a couple of plain class
  // names the stylesheet also understands (no ":has()" involved), so
  // the important, correctness-affecting behaviour works everywhere,
  // not just on the newest browsers.
  function applyStructuralFallbacks() {
    try {
      form.querySelectorAll('#teeFormInputs .tee-toggle-wrapper.tee-visibility-control').forEach(function (wrapper) {
        var checkbox = wrapper.querySelector('.tee-switch__input');
        var input = wrapper.nextElementSibling;
        if (!checkbox || !input || !input.classList.contains('tee-field__input')) return;
        var row = input.querySelector('.tee-clipart-row');
        var hasContent = !!(row && row.children.length);
        setClass(input, 'tib-toggle-has-content', !!(checkbox.checked && hasContent));
      });

      form.querySelectorAll('#teeFormInputs .tee-field:not(.sr-only)').forEach(function (field) {
        var hasToggle = !!field.querySelector('.tee-toggle-wrapper');
        var isStatic = field.classList.contains('tee-field--static');
        var row = field.querySelector('.tee-field__input > .tee-clipart-row');
        var isEmptyRow = !!(row && !row.children.length);
        setClass(field, 'tib-step-skip', !hasToggle && (isStatic || isEmptyRow));
      });
      return true;
    } catch (err) {
      return false;
    }
  }

  function runAll() {
    var a = insertBenefits();
    var b = normalizeClipartBoxes();
    var c = applyStructuralFallbacks();
    return a && b && c;
  }

  var observer = null;
  var isApplying = false;
  var scheduleHandle = null;
  var runsInWindow = 0;
  var windowStart = 0;
  var circuitOpen = false;
  var lastDocHeight = 0;
  var growthStreak = 0;

  function tripCircuit(reason) {
    if (circuitOpen) return;
    circuitOpen = true;
    if (observer) observer.disconnect();
    if (window.console && console.warn) {
      console.warn('[TIB] Layout-Schleife erkannt (' + reason + ') - Normalisierung wurde gestoppt.');
    }
  }

  // Alles, was das DOM anfasst, laeuft ausschliesslich hier durch.
  // "isApplying" verhindert Re-Entry, "takeRecords()" verwirft die
  // MutationRecords, die unsere EIGENEN Schreibvorgaenge gerade
  // erzeugt haben - sonst ruft der Observer uns unmittelbar wieder
  // auf und die Schleife startet erneut.
  function applyNow() {
    if (isApplying || circuitOpen) return false;
    isApplying = true;
    try {
      return runAll();
    } finally {
      if (observer) observer.takeRecords();
      isApplying = false;
      // Zweite, unabhaengige Notbremse: wenn die Seite nach mehreren
      // aufeinanderfolgenden Durchlaeufen immer weiter waechst, ist
      // irgendwo eine Rueckkopplung im Spiel, die wir nicht bedacht
      // haben. Dann lieber abschalten als die Seite endlos strecken.
      var docHeight = document.documentElement.scrollHeight;
      if (lastDocHeight && docHeight > lastDocHeight + 8) {
        growthStreak += 1;
        if (growthStreak >= 5) tripCircuit('Seite waechst fortlaufend');
      } else {
        growthStreak = 0;
      }
      lastDocHeight = docHeight;
    }
  }

  // Trailing-Throttle statt "einmal pro Frame". Zusaetzlich ein
  // Sicherungsautomat: laeuft die Normalisierung trotz allem mehr als
  // 12x pro Sekunde, ist irgendwo ein Aufschaukeln im Spiel - dann
  // lieber sauber abschalten (Layout bleibt beim letzten guten Stand)
  // als die Seite unbrauchbar machen.
  function schedule() {
    if (circuitOpen || scheduleHandle !== null) return;
    scheduleHandle = setTimeout(function () {
      scheduleHandle = null;
      var now = Date.now();
      if (now - windowStart > 1000) {
        windowStart = now;
        runsInWindow = 0;
      }
      runsInWindow += 1;
      if (runsInWindow > 12) {
        tripCircuit('mehr als 12 Laeufe/Sekunde');
        return;
      }
      applyNow();
    }, 160);
  }

  applyNow();
  var tries = 0;
  var timer = setInterval(function () {
    tries += 1;
    // 40 tries at 300ms (12s total) covers even a slow mobile
    // connection loading the app widget - after that the
    // MutationObserver below still keeps watching indefinitely, so
    // nothing is ever permanently missed, this just stops the
    // short-lived polling once it's no longer needed.
    if (applyNow() || tries >= 40) clearInterval(timer);
  }, 300);

  // The app re-renders swatch rows dynamically (e.g. selecting a breed
  // from a dropdown reveals its colour variants, or toggling
  // "Anzeigen/Ausblenden") - keep everything correct whenever the
  // form's DOM changes. Unlike the interval above, this keeps running
  // for as long as the page is open, so it also catches anything that
  // only appears after a very long delay (slow network, slow device)
  // or after the customer has been interacting with the page for a
  // while.
  observer = new MutationObserver(function () {
    if (isApplying) return;
    schedule();
  });
  observer.observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['checked', 'class'] });

  // A toggle's checked state doesn't always trigger a DOM mutation the
  // observer above would catch (it's an attribute the app may update
  // via a JS property rather than the HTML attribute) - listen for the
  // actual change event directly as an extra safeguard.
  form.addEventListener('change', function (event) {
    if (event.target && event.target.classList && event.target.classList.contains('tee-switch__input')) {
      applyStructuralFallbacks();
    }
  });

  var resizeTimer = null;
  var lastResizeWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    // WICHTIG (iOS/Android): beim Scrollen faehrt die Adressleiste
    // ein und aus. Das feuert ein "resize" - obwohl sich die BREITE
    // und damit das Kachel-Layout ueberhaupt nicht geaendert hat.
    // Frueher wurde dadurch bei praktisch jeder Scrollbewegung neu
    // gemessen und Padding geschrieben; das aenderte die Seitenhoehe,
    // was wiederum Scroll-Anchoring/Sticky ins Rutschen brachte
    // (Symptom: Seite springt hoch, Container waechst).
    // Deshalb: nur reagieren, wenn sich die Breite wirklich aendert.
    if (window.innerWidth === lastResizeWidth) return;
    lastResizeWidth = window.innerWidth;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { applyNow(); }, 150);
  });

  // iOS/Safari (and some Android browsers) can restore this exact page
  // from the back/forward cache without re-running any of the above -
  // "pageshow" with persisted=true fires in that case and is a cheap,
  // safe moment to re-check everything is still correct.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) applyNow();
  });
  }
})();
